import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    dimensions: null,
    app:null,
    maskSprite:null,
    canvasAsImage:null,
    activeObject: null,
    loading: true,
};

const pixiCanvasSlice = createSlice({
    name: 'canvas',
    initialState,
    reducers: {
        setDimensions: (state, action) => {
            state.dimensions = action.payload;
        },
        setCanvas: (state, action) => {
            state.app = action.payload;
        },
        setMaskSprite: (state, action) => {
            state.maskSprite = action.payload;
        },
        setPixiCanvasAsImage:(state, action)=>{
            state.canvasAsImage = action.payload
        },
        setPixiActiveObject:(state, action)=>{
            state.activeObject = action.payload
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
          },
    },
});

export const { setDimensions, setCanvas,setMaskSprite, setPixiCanvasAsImage, setPixiActiveObject, setLoading, } = pixiCanvasSlice.actions;

export default pixiCanvasSlice.reducer;
